var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLogoNoText = function SvgLogoNoText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 909 909",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 909,
    height: 909,
    rx: 909,
    fill: "#ff0051"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,70) scale(0.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.24,214.73l129.97-80.19c11.44-6.48,11.43-19.84,3.2-28.02L44.85,1.59c-2.13-2.12-5.58-2.11-7.7,.02l-10.25,10.31c-13.12,13.2-13.06,34.53,.13,47.66l42.37,39.11c7.2,7.16,5.83,19.17-2.8,24.52l-50.65,31.01C.13,164.02-4.74,184.8,5.06,200.61l7.66,12.35c1.59,2.56,4.96,3.35,7.52,1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M145.65,645c10.67-46.17-1.98-94.63-33.86-129.69L29.74,422.26C-15.94,370.47-4.65,290.13,53.54,252.93l134.26-85.83c8.67-5.54,19.98-4.53,27.54,2.45,49.12,45.31,220.01,208.56,212.43,377.15,0,0,.2,261.81-257.63,359.79-37.88,14.4-76.24-20.23-66.32-59.53,35.62-141.13,41.83-201.97,41.83-201.97Zm33.6-403.14c-20.53,13.01-60.31,38.21-94.26,59.73-22.72,14.4-27.3,45.61-9.71,65.96l85.79,99.2c49.16,54.07,68.67,128.81,52.21,200l-14.38,63.09c-6.25,27.4,26.09,46.56,47.36,28.2,90.39-78.03,217.13-265.6-47.19-514.33-5.39-5.07-13.56-5.81-19.81-1.85Z"
  }))))));
};
export default SvgLogoNoText;